import TagManager from 'react-gtm-module'
import { ICourse } from 'stores/courses'
import { convertToEcommerceItem } from '@/shared/utils/convertFormatForGTM'

// GA 향상된 전자상거래 - enhanced ecommerce
// GA4 전자상거래 - ecommerce
export const onBeginCheckout = (course: ICourse) => {
  TagManager.dataLayer({
    dataLayer: {
      ecommerce: null,
    },
  })
  TagManager.dataLayer({
    dataLayer: {
      event: 'begin_checkout',
      ecommerce: {
        items: [convertToEcommerceItem(course)],
      },
      ...(sessionStorage.getItem('utmAndGclid') &&
        JSON.parse(sessionStorage.getItem('utmAndGclid') as string)),
    },
  })
}
